import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const NoData = (props) => (_jsxs("div", { className: "text-center py-5", children: [_jsx("i", { className: `bi bi-${props.icon} text-muted`, style: { 'fontSize': '2.5rem' } }), _jsx("p", { className: "text-muted mt-2 mb-0", children: props.message })] }));
export default NoData;
